import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  HostListener,
  ElementRef,
  Inject,
  NgZone,
  PLATFORM_ID,
  DOCUMENT
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { MatDialog } from '@angular/material/dialog';
import { DialogContentConsultDialog } from '../models/consult-now/page/consult-content';
import { DomSanitizer, SafeHtml, Title } from '@angular/platform-browser';
import * as lottie from 'lottie-web';
import { description } from '../SEO_Constant/seo';
import { title } from 'process';

interface AbFloat {
  icon: SafeHtml;
  label: string;
  pos: string;
}

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.css'],
    standalone: false
})
export class AboutUsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('myDOMElement', { static: true }) MyDOMElement?: ElementRef;
  @ViewChild('abIntro') abIntro?: ElementRef<HTMLElement>;

  abFloats: AbFloat[] = [];
  private abCleanups: Array<() => void> = [];
  picArray = new Array();

  // FOR OUR TEAM

  experts = [
    // {img: "assets/images/pankaj.jpg",tittle:"Pankaj Mishra" ,position:"Director & CEO"},
    // {img: "assets/images/prateek.jpg",tittle:"Prateek Saluja",position:"Director & CEO"},
    // {img: "https://images.prismic.io/kurmishadi/f9399423-6c8b-4843-8be2-8e2f2196184c_preeti.jpg?auto=compress,format",tittle:"Preeti sahu ",position:"HR"},//assets/images/team leaders/preeti.jpg
    {
      img: '/assets/images/image/sushant-for-team.webp',
      tittle: 'Sushant Saluja',
      position: 'Functional Manager',
    },
    {
      img: 'https://images.prismic.io/kurmishadi/65de2683-a34a-4e43-8804-a5fef77bdd56_deepak.jpg?auto=compress,format',
      tittle: 'Deepak Verma',
      position: 'Manager',
    }, //assets/images/deepak.jpg
    {
      img: 'https://images.prismic.io/kurmishadi/45e2f9ca-80fb-4985-bc7b-86ab530e9db5_ankita.jpeg?auto=compress,format',
      tittle: 'Ankita choudhary ',
      position: 'Senior Angular Developer',
    }, //assets/images/team leaders/ankita.jpeg
    {
      img: 'https://images.prismic.io/kurmishadi/0fc62679-7b52-41c8-ae81-51d7ec8a01e7_irshad.jpg?auto=compress,format',
      tittle: 'Irshad Alam',
      position: 'Senior Web Designer',
    }, //assets/images/team leaders/irshad.jpg
    // {img: "https://images.prismic.io/kurmishadi/2f54afc1-8b71-4e08-a4e7-59084c31c2c7_swarna.jpg?auto=compress,format",tittle:"Swarna Tiwari",position:"Marketing Executive"},//assets/images/team leaders/swarna.jpg
    {
      img: 'https://images.prismic.io/kurmishadi/63828c9d-5c63-4022-a098-2ab1bc80e410_shreya.jpg?auto=compress,format',
      tittle: 'Shreya Gupta',
      position: 'Senior Software Developer',
    }, //assets/images/team leaders/mahendra.jpg
    {
      img: '/assets/images/image/manish.webp',
      tittle: 'Manish Chandra',
      position: 'Senior React  Developer',
    },
  ];

  expertsConfig = {
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1800,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // end

  constructor(
    private title: Title,
    private zone: NgZone,
    private dialog: MatDialog,
    sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private abPlatformId: Object
  ) {
    const svg = (path: string) =>
      sanitizer.bypassSecurityTrustHtml(
        `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="1.7" stroke-linecap="round"
              stroke-linejoin="round">${path}</svg>`
      );
    this.abFloats = [
      {
        icon: svg('<path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-4 10.5c.6.6 1 1.5 1 2.5h6c0-1 .4-1.9 1-2.5A6 6 0 0 0 12 3z"/>'),
        label: 'Innovation',
        pos: 'a',
      },
      {
        icon: svg('<path d="M3 20V10M9 20V4M15 20v-7M21 20V8"/>'),
        label: 'Growth',
        pos: 'b',
      },
      {
        icon: svg('<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>'),
        label: 'Teamwork',
        pos: 'c',
      },
      {
        icon: svg('<path d="M3 3v18h18"/><path d="m7 15 4-4 3 3 5-6"/>'),
        label: 'Analytics',
        pos: 'd',
      },
    ];

  }

  /** Scroll reveal for the two redesigned sections; visible by default. */
  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.abPlatformId)) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    [this.abIntro].forEach((ref) => {
      const el = ref?.nativeElement;
      if (!el) return;
      if (reduced) {
        el.classList.add('is-in');
        return;
      }
      el.classList.add('js-anim');
      if (el.getBoundingClientRect().top < window.innerHeight * 0.85) {
        el.classList.add('is-in');
      } else {
        const io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((e) => e.isIntersecting)) return;
            el.classList.add('is-in');
            io.disconnect();
          },
          { threshold: 0, rootMargin: '0px 0px -12% 0px' }
        );
        this.zone.runOutsideAngular(() => io.observe(el));
        this.abCleanups.push(() => io.disconnect());
      }

      // very subtle cursor parallax
      let queued = false;
      let x = 0,
        y = 0;
      const apply = () => {
        queued = false;
        el.style.setProperty('--px', x.toFixed(4));
        el.style.setProperty('--py', y.toFixed(4));
      };
      const onMove = (e: MouseEvent) => {
        const r = el.getBoundingClientRect();
        x = (e.clientX - r.left) / r.width - 0.5;
        y = (e.clientY - r.top) / r.height - 0.5;
        if (queued) return;
        queued = true;
        requestAnimationFrame(apply);
      };
      this.zone.runOutsideAngular(() =>
        el.addEventListener('mousemove', onMove, { passive: true })
      );
      this.abCleanups.push(() => el.removeEventListener('mousemove', onMove));
    });
  }

  ngOnDestroy(): void {
    this.abCleanups.forEach((fn) => fn());
    this.abCleanups = [];
  }

  /** Contact CTA — <app-contact> emits, the page owns the dialog. */
  openConsultDialog(): void {
    this.dialog.open(DialogContentConsultDialog);
  }

  ngOnInit(): void {
    this.title.setTitle('About | Resiliencesoft');

    for (let i = 1; i < 9; i++) {
      this.picArray.push({
        img_name: '/assets/images/our-teams/(' + i + ').svg',
        img_caption: 'Workplace Picture ' + i,
      });
    }
  }

  clientFeedback = [
    {
      description:
        'Resiliencesoft truly impressed us with their mobile app development skills. Our app was delivered on time and exceeded our expectations in terms of functionality and design. Highly recommended!',

      title: 'Sarah Johnson',
      country: 'USA',
    },
    {
      description:
        'We engaged Resiliencesoft for website development and were blown away by their professionalism and creativity. They understood our vision perfectly and brought it to life flawlessly. Great job!',
      title: ' David Thompson',
      country: 'Canada',
    },
    {
      description:
        'The team at Resiliencesoft is exceptional at product development. They helped us refine our concept into a market-ready product efficiently. Their attention to detail and commitment to quality are unmatched.',
      title: 'Ahmed Al-Mansoori',
      country: 'Saudi Arabia',
    },
    {
      description:
        "Resiliencesoft's Social Media management services have significantly boosted our online presence. They are proactive, responsive, and have a deep understanding of social media dynamics. We're thrilled with the results!",
      title: 'Isabella Bianchi',
      country: 'Australia',
    },
    {
      description:
        "Choosing Resiliencesoft for our Digital Media needs was one of the best decisions we made. Their strategic approach and innovative ideas have elevated our brand's visibility and engagement. Thank you!",
      title: 'Markus Müller',
      country: 'Germany',
    },
    {
      description:
        'Resiliencesoft has been instrumental in our mobile app development journey. They brought fresh ideas to the table and executed them with precision. Their technical expertise is commendable.',
      title: 'Emily Wilson',
      country: 'UK',
    },
    {
      description:
        "We are extremely satisfied with Resiliencesoft's website development services. They were quick to grasp our requirements and delivered a website that reflects our brand perfectly. Highly recommended!",
      title: 'Pieter van der Berg',
      country: 'Netherlands',
    },
    {
      description:
        "Kudos to Resiliencesoft for their outstanding product development skills. They turned our concept into reality seamlessly. The team's dedication and expertise are truly impressive.",
      title: 'Sophie Meier',
      country: 'Switzerland',
    },
    {
      description:
        "Resiliencesoft's Social Media management team is top-notch. They have significantly improved our social media engagement and brand awareness. It's been a pleasure working with them.",
      title: " Liam O'Brien",
      country: 'Ireland',
    },
    {
      description:
        "Our experience with Resiliencesoft for Digital Media services has been fantastic. They understand our brand's voice and have helped us connect with our audience effectively. We look forward to continuing this partnership!",
      title: 'Sophie Meier',
      country: 'Switzerland',
    },
  ];

  // FOR CLIENTS
  slideConfigmsg = {
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1800,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  //   loadLottieAnimation(): void {
  //     const animationContainer = document.getElementById('lottie-container'); // Assuming you have a container with id 'lottie-container'
  //     const animationData = require('path/to/your/animation.json'); // Import animation JSON file
  //     const animation = lottie.loadAnimation({
  //         container: animationContainer,
  //         renderer: 'svg',
  //         loop: true,
  //         autoplay: true,
  //         animationData: animationData
  //     });
  // }

  //end
}
